import PAGES from './pages'

export const MAIN_PATHS = {
  DATA: 'data',
  MAP: 'kaart',
}

// TODO: Refactor this file once redux-first-router has been removed from the project.
export interface Route {
  title: string
  path: string
  page: string
}

export const routing: { [key: string]: Route } = {
  /**
   * Core pages
   */
  addressDetail: {
    title: 'Adres',
    path: `/adressen/:id/:slug?/`,
    page: PAGES.ONE_DESIGN,
  },
  addresses: {
    title: 'Adres',
    path: `/${MAIN_PATHS.DATA}/bag/adressen/`,
    page: PAGES.ADDRESSES,
  },
  bouwblokDetail: {
    title: 'Bouwblok',
    path: `/bouwblokken/:id/:slug?/`,
    page: PAGES.ONE_DESIGN,
  },
  buurtDetail: {
    title: 'Buurt',
    path: `/buurten/:id/:slug?/`,
    page: PAGES.ONE_DESIGN,
  },
  cadastralObjects: {
    title: 'Kadastraal object',
    path: `/${MAIN_PATHS.DATA}/brk/kadastrale-objecten/`,
    page: PAGES.CADASTRAL_OBJECTS,
  },
  catalogOverview: {
    title: 'Catalogus',
    path: '/catalogus/',
    page: PAGES.CATALOG_OVERVIEW,
  },
  catalogDetail: {
    title: 'Catalogus',
    path: '/catalogus/:id/',
    page: PAGES.CATALOG_DETAIL,
  },
  complexDetail: {
    title: 'Complex',
    path: `/complexen/:id/`,
    page: PAGES.ONE_DESIGN,
  },
  constructionDossier: {
    title: 'Bouwdossier',
    path: `/${MAIN_PATHS.DATA}/bouwdossiers/bouwdossier/:id/`,
    page: PAGES.CONSTRUCTION_DOSSIER,
  },
  constructionDossierList: {
    title: 'Bouwdossiers',
    path: `/bouwdossiers/`,
    page: PAGES.CONSTRUCTION_DOSSIER_LIST,
  },
  data: {
    title: 'Data',
    path: `/${MAIN_PATHS.DATA}/`,
    page: PAGES.DATA,
  },
  dataDetail: {
    title: 'Data detail',
    path: `/${MAIN_PATHS.DATA}/:type/:subtype/:id/`,
    page: PAGES.DATA_DETAIL,
  },
  dataSearchGeo: {
    title: 'Data zoekresultaten op locatie',
    path: `/${MAIN_PATHS.DATA}/geozoek/`,
    page: PAGES.DATA_SEARCH_GEO,
  },
  drawTool: {
    title: 'Intekenen',
    path: `/${MAIN_PATHS.DATA}/draw/`, // slug here is optional by appending "?"
    page: PAGES.DRAW,
  },
  establishments: {
    title: 'Vestiging',
    path: `/${MAIN_PATHS.DATA}/hr/vestigingen/`,
    page: PAGES.ESTABLISHMENTS,
  },
  gebiedsGerichtWerkenDetail: {
    title: 'Gebiedsgericht werken',
    path: `/gebiedsgerichtwerken/:id/`,
    page: PAGES.ONE_DESIGN,
  },
  stedelijkGebiedProjectOfBelangenDetail: {
    title: 'Stedelijk gebied, project of belang',
    path: `/stedelijke-gebieden-projecten-of-belangen/:id/`,
    page: PAGES.ONE_DESIGN,
  },
  home: {
    title: 'Home',
    path: '/',
    page: PAGES.HOME,
  },
  kadastraalObjectDetail: {
    title: 'Kadastraal object',
    path: `/kadastrale-objecten/:id/`,
    page: PAGES.ONE_DESIGN,
  },
  kadastraalSubjectDetail: {
    title: 'Kadastraal subject',
    path: `/kadastrale-subjecten/:id/`,
    page: PAGES.ONE_DESIGN,
  },
  monumentDetail: {
    title: 'Monument',
    path: `/monumenten/:id/:slug?/`,
    page: PAGES.ONE_DESIGN,
  },
  maDetail: {
    title: 'Maatschappelijke activiteit',
    path: `/maatschappelijke-activiteiten/:id/`,
    page: PAGES.ONE_DESIGN,
  },
  mapSearch: {
    title: 'Kaartlagen',
    path: `/${MAIN_PATHS.DATA}/geozoek/`,
    page: PAGES.DATA_SEARCH_GEO,
  },
  notFound: {
    title: 'Pagina niet gevonden',
    path: '/niet-gevonden/',
    page: PAGES.NOT_FOUND,
  },
  pandDetail: {
    title: 'Pand',
    path: `/panden/:id/`,
    page: PAGES.ONE_DESIGN,
  },
  openbareRuimteDetail: {
    title: 'Openbare ruimte',
    path: `/openbare-ruimten/:id/`,
    page: PAGES.ONE_DESIGN,
  },
  search: {
    title: 'Zoekresultaten',
    path: `/zoek/`,
    page: PAGES.SEARCH,
  },
  stadsdeelDetail: {
    title: 'Stadsdeel',
    path: `/stadsdelen/:id/`,
    page: PAGES.ONE_DESIGN,
  },
  vestigingDetail: {
    title: 'Vestiging',
    path: `/vestigingen/:id/`,
    page: PAGES.ONE_DESIGN,
  },
  wijkDetail: {
    title: 'Wijk',
    path: `/wijken/:id/`,
    page: PAGES.ONE_DESIGN,
  },
  woonplaatsDetail: {
    title: 'Woonplaats',
    path: `/woonplaatsen/:id/`,
    page: PAGES.ONE_DESIGN,
  },

  /**
   * Static pages
   */
  about: {
    title: 'Over de organisatie',
    path: '/over-ons/',
    page: PAGES.ABOUT,
  },
  aboutWebsite: {
    title: 'Over deze site',
    path: '/over-deze-site/',
    page: PAGES.ABOUT_WEBSITE,
  },
  accessibility: {
    title: 'Toegankelijkheidsverklaring',
    path: '/toegankelijkheidsverklaring/',
    page: PAGES.ACCESSIBILITY,
  },
  analyseSuiteDetail: {
    title: 'Analyse Suite',
    path: '/dataplatform-services/analyse-suite/',
    page: PAGES.ANALYSE_SUITE,
  },
  compliancyAuditDetail: {
    title: 'Compliancy en audit',
    path: '/dataplatform-services/compliancy-audit/',
    page: PAGES.COMPLIANCY_AUDIT,
  },
  contact: {
    title: 'Contact',
    path: '/contact/',
    page: PAGES.CONTACT,
  },
  dataContact: {
    title: 'Gegevens',
    path: '/gegevens/',
    page: PAGES.DATA_CONTACT,
  },
  dataPlatformServices: {
    title: 'Dataplatform services',
    path: '/dataplatform-services/',
    page: PAGES.DATA_PLATFORM_SERVICES,
  },
  dataProcessingDetail: {
    title: 'Dataverwerking',
    path: '/dataplatform-services/dataverwerking/',
    page: PAGES.DATA_PROCESSING_DETAIL,
  },
  datasetCatalogDetail: {
    title: 'Dataproducten beschikbaar stellen',
    path: '/dataplatform-services/catalogus/',
    page: PAGES.DATASET_CATALOG_DETAIL,
  },
  employees: {
    title: 'Alleen voor medewerkers',
    path: '/alleen-voor-medewerkers/',
    page: PAGES.EMPLOYEES,
  },
  faq: {
    title: 'Veelgestelde vragen',
    path: '/veelgestelde-vragen/',
    page: PAGES.FAQ,
  },
  features: {
    title: 'Wat kun je allemaal op deze site?',
    path: '/uitleg-gebruik/',
    page: PAGES.FEATURES,
  },
  help: {
    title: 'Help',
    path: `/help/`,
    page: PAGES.HELP,
  },
  interactiveTablesDetail: {
    title: 'Interactieve Tabellen',
    path: '/dataplatform-services/interactieve-tabellen/',
    page: PAGES.INTERACTIVE_TABLES_DETAIL,
  },
  mapLayerDetail: {
    title: 'Kaartlagen',
    path: '/dataplatform-services/kaartlagen/',
    page: PAGES.MAP_LAYER_DETAIL,
  },
  mapLayersInfo: {
    title: 'Informatie over kaartlagen',
    path: '/informatie-over-kaartlagen/',
    page: PAGES.MAP_LAYERS_INFO,
  },
  quality: {
    title: 'Beschikbaarheid en kwaliteit data',
    path: '/beschikbaarheid-kwaliteit-data/',
    page: PAGES.QUALITY,
  },
  services: {
    title: 'Data Services',
    path: '/services/',
    page: PAGES.SERVICES,
  },
  standardisedInformationServicesDetail: {
    title: 'Gestandaardiseerde informatiediensten',
    path: '/dataplatform-services/gestandaardiseerde-informatiediensten/',
    page: PAGES.STANDARDISED_INFORMATION_SERVICES,
  },
  tables: {
    title: 'Data in tabellen',
    path: '/tabellen/',
    page: PAGES.TABLES,
  },
  technicalManagement: {
    title: 'Technisch beheer',
    path: '/technisch-beheer-werkwijze/',
    page: PAGES.TECHNICAL_MANAGEMENT,
  },

  /**
   * Dossier Ondergrond
   */
  undergroundSoilQuality: {
    title: 'Milieu: Bodemkwaliteit',
    path: '/dossiers/milieu/bodemkwaliteit/',
    page: PAGES.ENVIRONMENT_SOIL_QUALITY,
  },
  undergroundSoilComposition: {
    title: 'Milieu: Bodemopbouw',
    path: '/dossiers/milieu/bodemopbouw/',
    page: PAGES.ENVIRONMENT_SOIL_COMPOSITION,
  },
  undergroundGroundwater: {
    title: 'Watersystemen: Grondwater',
    path: '/dossiers/watersystemen/grondwater/',
    page: PAGES.GROUND_WATER,
  },
  undergroundDikes: {
    title: 'Watersystemen: Dijklichamen',
    path: '/dossiers/watersystemen/dijklichamen/',
    page: PAGES.DIKES,
  },
  undergroundClimate: {
    title: 'Kilmaatadaptie',
    path: '/dossiers/klimaatadaptie/klimaatadaptie/',
    page: PAGES.CLIMATE,
  },
  undergroundArcheology: {
    title: 'Archeologie',
    path: '/dossiers/archeologie/archeologie/',
    page: PAGES.CLIMATE,
  },
  undergroundCablesPipes: {
    title: 'Kabels en leidingen',
    path: '/dossiers/kabels-en-leidingen/kabels-en-leidingen/',
    page: PAGES.CABLES_PIPES,
  },
  undergroundEnergy: {
    title: 'Energie',
    path: '/dossiers/energie/energie/',
    page: PAGES.ENERGY,
  },
  undergroundTreesGreens: {
    title: 'Bomen en groen,',
    path: '/dossiers/bomen-en-groen/bomen-en-groen/',
    page: PAGES.TREES_GREENS,
  },
  undergroundJapaneseTree: {
    title: 'Bomen en groen: Japanse duizendknoop,',
    path: '/dossiers/bomen-en-groen/japanse-duizendknoop/',
    page: PAGES.JAPANESE_TREE,
  },
  undergroundObstacles: {
    title: 'Ondergrondse objecten: Bestaande ondergrondse obstakels,',
    path: '/dossiers/ondergrondse-objecten/bestaande-ondergrondse-obstakels/',
    page: PAGES.UNDERGROUND_OBJECTS,
  },
  undergroundSpaceUtilization: {
    title: 'Ondergrondse objecten: Ondergronds ruimtegebruik,',
    path: '/dossiers/ondergrondse-objecten/ondergronds-ruimtegebruik/',
    page: PAGES.UNDERGROUND_SPACE,
  },
  undergroundMoblity: {
    title: 'Ondergrondse objecten: Mobiliteit,',
    path: '/dossiers/ondergrondse-objecten/mobiliteit/',
    page: PAGES.UNDERGROUND_MOBILITY,
  },
  amsterdamUnderground: {
    title: 'De Amsterdamse ondergrond',
    path: '/dossiers/de-amsterdamse-ondergrond/',
    page: PAGES.AMSTERDAM_UNDERGROND,
  },
  archiveMapHistoric: {
    title: 'Archief en kaart historische onderzoeken ondergrond',
    path: '/dossiers/archief-en-kaart-historische-onderzoeken-ondergrond/',
    page: PAGES.ARCHIVE_MAP_HISTORIC,
  },
  broPilot3dModel: {
    title: 'BRO-pilot 3D-model Amstelstad',
    path: '/dossiers/bro-pilot-3d-model-amstelstad/',
    page: PAGES.BRO_PILOT_3D_MODEL,
  },
  undergroundDossier: {
    title: 'De ondergrond van Amsterdam',
    path: '/dossiers/ondergrond/',
    page: PAGES.UNDERGROUND_DOSSIER,
  },
}

/**
 * We need to check if the route paths have a trailing slash
 */
Object.values(routing).forEach((value) => {
  if (value.path.substring(value.path.length - 1) !== '/') {
    console.warn(`Route for "${value.title}" doesn't have trailing slash`)
  }
})
